module.exports = __webpack_public_path__ + "img/tuvalu.2ec1e7df.svg";